<template>
  <div class="notice-modal" :style="modalPosition">
    <h6 class="fw-bold text-primary">공 지 사 항</h6>
    <div class="notice-content" v-html="content.replace(/\n/g, '<br>')"></div>
    <div class="notice-actions">
      <button class="btn btn-outline-primary btn-sm" @click="$emit('close')">확인</button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    content: { type: String, required: true },
    idx: { type: Number, required: true }
  },
  computed: {
    modalPosition() {
      const startX = 10;
      const startY = 20;
      const modalWidth = 350;
      const gap = 20;
      const offsetX = modalWidth + gap;
      
      return {
        left: `${startX + this.idx * offsetX}px`,
        top: `${startY}px`,
        position: 'fixed',
        zIndex: 9999 + this.idx
      };
    }
  }
}
</script>

<style scoped>
.notice-modal {
  background: #fffdfd; 
  border-radius: 8px; 
  padding: 2rem; 
  width: 350px; 
  max-width: 90vw;
  box-shadow: 0 8px 32px rgba(0,0,0,0.2);
  border: 1px solid #e0e0e0;
}

.notice-actions { 
  margin-top: 1.5rem; 
  display: flex; 
  gap: 0.5rem; 
  justify-content: flex-end; 
}

.notice-content { 
  margin-top: 1rem;
  line-height: 1.5;
  word-wrap: break-word;
}

/* 반응형 처리 */
@media (max-width: 768px) {
  .notice-modal {
    width: 300px;
  }
}
</style>
